<lib-side-menu
  (avatarClick)="showPopover()"
  (isOpenedMenuChange)="toggleSidenav($event)"
  (listItemClick)="itemClick()"
  (logout)="handleIsWarningAboutNotSavedOrSentMeasurementsVisible()"
  [(popoverVisible)]="popoverVisible"
  [customTemplateContent]="rn"
  [deviceName]="isMobile ? (currentUserDevice$ | async)?.id || '-' : ''"
  [isMobile]="isMobile || (isForcedResolution$ | async)"
  [isOpened]="!(isCollapsedMenu$ | async)"
  [isUserRN]="!(isUserCNA$ | async)"
  [items]="sideMenuItems$ | async"
  [logoutHidden]="hasCNAAccessToken()"
  [nzPopoverContent]="contentTemplate"
  [user]="user$ | async"
  [isSimulationMode]="isSimulationMode()" />
<ng-template #rn>
  @if (isMobile) {
    <button class="rn-btn reload" (click)="refreshPage()">
      <span nz-icon nzType="reload" nzTheme="outline"> </span>
      <span>Refresh</span>
    </button>
    @if (
      !isUserAdmin() &&
      !(isUserCNA$ | async) &&
      (currentUserDevice$ | async)?.id !== '-' &&
      (currentDepartments$ | async)
    ) {
      <button
        class="rn-btn"
        [disabled]="isSimulationMode()"
        (click)="showSpotlightTable()">
        <span nz-icon nzType="aio:menu-spotlight-table" nzTheme="outline">
        </span>
        <span>Spotlight table</span>
      </button>
    }
    <button
      [attr.data-cy]="'wifi-settings'"
      class="rn-btn"
      (click)="selectNetwork()">
      <span nz-icon nzType="aio:wifi-regular"></span>
      <span>Choose network</span>
    </button>
    <button
      class="rn-btn"
      [attr.data-cy]="'device-pairing'"
      [disabled]="isSimulationMode()"
      (click)="pairDevices()">
      <span nz-icon nzType="link" nzTheme="outline"></span>
      <span>Device pairing</span>
    </button>
    @if (
      (isUserCNA$ | async) &&
      !(isPccUser$ | async) &&
      (currentUserDevice$ | async)?.id !== '-'
    ) {
      <button class="rn-btn" (click)="showModalLoginToPcc()">
        <span nz-icon nzType="aio:stethoscope"></span>
        <span>Nurse sign in</span>
      </button>
    } @else {
      @if (hasCNAAccessToken()) {
        <button
          nz-button
          class="rn-btn"
          [nzLoading]="userLoading$ | async"
          (click)="handlerClickRnLogout()">
          <span nz-icon nzType="aio:heart-in-hands"></span>
          <span>Nurse sign out</span>
        </button>
      }
    }
    @if (!isUserAdmin()) {
      <button
        nz-button
        class="rn-btn"
        [class.no-border]="hasCNAAccessToken()"
        [nzLoading]="userLoading$ | async"
        [attr.data-cy]="'set-simulation-mode'"
        (click)="
          isSimulationMode()
            ? exitSimulationMode()
            : openEnterSimulationModePopup()
        ">
        <span nz-icon nzType="icons:flask-regular"></span>
        <span>
          @if (isSimulationMode()) {
            Exit Simulation
          } @else {
            Simulation Mode
          }
        </span>
      </button>
    }
    <nz-modal
      nzWidth="618px"
      nzMaskClosable="false"
      [nzVisible]="(isPccLogging$ | async) && !isSelectNetworkPopupShown()"
      (nzOnCancel)="hideModalLoginToPcc()"
      [nzFooter]="null"
      nzWrapClassName="pcc-login-modal tablet-center tablet-modal-wrapper"
      [nzStyle]="{
        top: '50%',
        transform: 'translateY(-50%)'
      }"
      nzNoAnimation>
      <ng-container *nzModalContent>
        <div class="pcc-login-modal__header">
          <div class="title">Nurse login</div>
          <div class="title-close" (click)="hideModalLoginToPcc()">
            Close
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none">
              <path
                d="M24.5427 21.9972L37.4334 6.63159C37.6494 6.37623 37.4678 5.98828 37.1338 5.98828H33.2151C32.9843 5.98828 32.7633 6.09141 32.6111 6.26819L21.9794 18.9427L11.3477 6.26819C11.2003 6.09141 10.9794 5.98828 10.7436 5.98828H6.82489C6.49096 5.98828 6.30927 6.37623 6.52534 6.63159L19.416 21.9972L6.52534 37.3628C6.47694 37.4198 6.44588 37.4894 6.43587 37.5634C6.42585 37.6374 6.43729 37.7128 6.46883 37.7805C6.50037 37.8483 6.55069 37.9055 6.6138 37.9455C6.67691 37.9855 6.75018 38.0065 6.82489 38.0061H10.7436C10.9744 38.0061 11.1954 37.903 11.3477 37.7262L21.9794 25.0517L32.6111 37.7262C32.7584 37.903 32.9794 38.0061 33.2151 38.0061H37.1338C37.4678 38.0061 37.6494 37.6182 37.4334 37.3628L24.5427 21.9972Z"
                fill="#263558" />
            </svg>
          </div>
        </div>
        @if (!loginWithCred) {
          <div class="pcc-login-modal__description">
            {{ emrConfig().incrementalLoginPopupText }}
          </div>
        }
        <aiomed-login-tablet-nurse
          tab="rn"
          [hasError]="!!(errorMessage$ | async)"
          [isLoading]="isAuthLoading$ | async"
          [isMobile]="true"
          [existingOrganization]="null"
          [preselectedOrganizationEmrType]="null"
          [isInlineLoginWithAiomedCredentialsDisplayed]="true"
          (onBlur)="adminCodeBlur()"
          (onFocus)="adminCodeFocus()"
          (loginWithCredEmitter)="loginWithCred = $event"
          (loginWithPcc)="loginWithPcc()"
          (formSubmitEmitter)="handlerFormSubmitEmitter($event)"
          (loginWithCredEmitter)="closeOpenedWindow()" />
      </ng-container>
    </nz-modal>
    <nz-modal
      nzCentered
      [nzVisible]="isPCCAccountUsagePopupVisible$ | async"
      [nzTitle]="'Log-in Settings'"
      (nzOnCancel)="hidePCCAccountUsagePopup()"
      (nzOnOk)="allowPCCAccountUsage()"
      nzCancelText="No"
      nzOkText="Yes, Enable"
      nzClassName="consent-modal">
      <ng-container *nzModalContent>
        You can simplify your future login process by using only your
        PointClickCare credentials. Would you like to enable this?
      </ng-container>
    </nz-modal>
    <nz-modal
      nzMaskClosable="false"
      [nzVisible]="
        isShowDevicePairing ||
        isLogoutConfirmModalOpened() ||
        isEnteringSimulationMode()
      "
      [nzFooter]="null"
      (nzOnCancel)="hideDevicePairing()"
      nzWrapClassName="tablet-center tablet-modal-wrapper"
      [nzClassName]="isDeviceChoosing ? 'device-pairing-modal' : ''"
      [nzStyle]="{
        top: '50%',
        transform: 'translateY(-50%)'
      }"
      nzNoAnimation
      [nzWidth]="isDeviceChoosing ? '720px' : '520px'">
      <ng-container *nzModalTitle>
        {{
          isEnteringSimulationMode()
            ? 'Enter code to start simulation'
            : isDeviceChoosing
              ? 'Device Pairing'
              : 'ADMIN PIN CODE'
        }}
      </ng-container>
      <ng-container *nzModalContent>
        <div class="device-choosing" (keydown.enter)="handleEnterClick($event)">
          @if (isDeviceChoosing) {
            @if (sharedDevices$ | async; as devices) {
              <nz-form-item>
                <nz-form-label>Main vital machine</nz-form-label>
                <nz-select
                  [(ngModel)]="selectedDeviceId"
                  class="small"
                  nzDropdownClassName="custom-login-department-select"
                  nzPlaceHolder="Choose your machine">
                  @for (device of devices; track device.id) {
                    <nz-option
                      [nzValue]="device.id"
                      [nzLabel]="device.id"></nz-option>
                  }
                </nz-select>
              </nz-form-item>
              <nz-form-item>
                <nz-form-label>Secondary device</nz-form-label>
                <nz-select
                  [nzShowSearch]="false"
                  [(ngModel)]="selectedSecondaryDevicesIds"
                  [nzShowArrow]="true"
                  nzMode="multiple"
                  class="small"
                  nzDropdownClassName="custom-login-department-select"
                  class="custom-login-department-select"
                  nzPlaceHolder="Choose your machine">
                  @for (device of devices; track device.id) {
                    <nz-option
                      [nzValue]="device.id"
                      [nzLabel]="device.id"></nz-option>
                  }
                </nz-select>
              </nz-form-item>
              <ng-template #nzMenuItemSelectedIcon>
                <span nz-icon nzType="check-square" nzTheme="outline"></span>
              </ng-template>
            }
            @if (departments(); as departments) {
              <nz-form-item>
                <nz-form-label>Departments</nz-form-label>
                <nz-select
                  [(ngModel)]="selectedDepartmentsIds"
                  (ngModelChange)="departmentSelectChange($event)"
                  class="small"
                  nzDropdownClassName="custom-login-department-select"
                  class="custom-login-department-select"
                  nzMode="multiple"
                  nzPlaceHolder="No Selected"
                  [nzMaxTagCount]="0"
                  [nzMaxTagPlaceholder]="maxTagPlaceholder">
                  <nz-option
                    [nzLabel]="defaultAllDepartment().name"
                    [nzValue]="defaultAllDepartment().id"
                    [nzCustomContent]="true">
                    <p (click)="allItemClick()">All</p>
                  </nz-option>
                  @for (department of departments; track department.id) {
                    <nz-option
                      [nzValue]="department.id"
                      [nzLabel]="department.name"></nz-option>
                  }
                  <ng-template #maxTagPlaceholder let-selectedList>
                    @let selectedListLength = selectedList.length;
                    {{
                      selectedListLength >= departments.length
                        ? 'All'
                        : selectedListLength === 1
                          ? firstSelectedDepartmentNameIfOnlyOneSelected()
                          : selectedListLength + ' Selected'
                    }}
                  </ng-template>
                </nz-select>
              </nz-form-item>
            }
            @if (patientsRooms(); as rooms) {
              <nz-form-item>
                <nz-form-label>Room assignment</nz-form-label>
                <nz-select
                  [nzShowSearch]="false"
                  [(ngModel)]="selectedRooms"
                  [nzShowArrow]="false"
                  [nzAllowClear]="true"
                  nzMode="multiple"
                  class="small"
                  nzDropdownClassName="custom-login-department-select"
                  class="custom-login-department-select"
                  nzPlaceHolder="Choose rooms">
                  @for (room of rooms; track room) {
                    <nz-option [nzValue]="room" [nzLabel]="room"></nz-option>
                  }
                </nz-select>
              </nz-form-item>
            }
            <button
              class="login-form__button connect"
              nz-button
              nzType="primary"
              [disabled]="
                !selectedDeviceId.length || !selectedDepartmentsIds()?.length
              "
              (click)="setCurrentDeviceAndDepartmentIds()">
              connect
            </button>
          } @else {
            <nz-input-number
              [attr.data-cy]="'admin-pincode'"
              #adminPinCodeField
              (nzFocus)="adminCodeFocus()"
              (nzBlur)="adminCodeBlur()"
              [formControl]="adminPinCode"
              [nzStatus]="
                adminPinCode.errors &&
                (adminPinCode.touched || adminPinCode.dirty)
                  ? 'error'
                  : ''
              "></nz-input-number>
            @if (
              adminPinCode.invalid &&
              (adminPinCode.touched || adminPinCode.dirty)
            ) {
              <small class="error">
                {{
                  adminPinCode.errors?.['minlength'] ||
                  adminPinCode.errors?.['maxlength']
                    ? 'PIN must be 4 digits long'
                    : adminPinCode.errors?.['required']
                      ? 'Please enter PIN code'
                      : 'Incorrect PIN. Please try again'
                }}
              </small>
            }
            @if (isEnteringSimulationMode()) {
              <button
                [class.btn-tablet]="isMobile"
                nz-button
                nzType="primary"
                [disabled]="!adminPinCode.valid"
                (click)="confirmEnteringSimulationMode()"
                [attr.data-cy]="'enter-simulation-mode'">
                Confirm
              </button>
            } @else {
              @if (!isLogoutConfirmModalOpened()) {
                <button
                  [class.btn-tablet]="isMobile"
                  nz-button
                  nzType="primary"
                  [disabled]="!adminPinCode.valid"
                  (click)="showDeviceChoosing()"
                  [attr.data-cy]="'device-choosing__show'">
                  Go To Device Choosing
                </button>
              } @else {
                <button
                  [class.btn-tablet]="isMobile"
                  nz-button
                  nzType="primary"
                  [disabled]="!adminPinCode.valid"
                  (click)="handlerClickLogout()">
                  Confirm logout
                </button>
              }
            }
          }
        </div>
      </ng-container>
    </nz-modal>
  }
  <!-- QA dev tools: render nothing unless the build enables them (angular.json) and the host is local or a QA preview. -->
  <aiomed-pa-qa-devtools />
</ng-template>
<ng-template #contentTemplate>
  <aiomed-user-popover
    (changeLanguageEmitter)="handlerChangeLanguageEmitter($event)"
    (reportIssue)="openReportIssueModal()"
    (navigateToProfile)="navigateToProfile()"
    [appVersion]="currentReleaseVersion()"
    [currentUser]="user$ | async"
    [language]="language$ | async"
    [isMobile]="isMobile"
    [isUserAdmin]="isUserAdmin()" />
</ng-template>

<aiomed-report-issue
  (cancelClick)="closeReportIssueModal()"
  (confirmClick)="reportIssueToLogRocket($event)"
  [isVisible]="reportIssueModalVisible"></aiomed-report-issue>

@if (isPccTokenInvalid) {
  <aiomed-warning-modal
    (closeModal)="isPccTokenInvalid = false"
    (saveModalDataEmitter)="isPccTokenInvalid = false"
    [isMobile]="isMobile"
    [width]="595"
    [hideSave]="true"
    closeText="OK"
    description="You've been logged out due to inactivity. Please log in again to continue"
    title="YOU’VE BEEN LOGGED OUT"></aiomed-warning-modal>
}

<ng-template #pccLoginTitle>
  <div class="pcc-login-modal__title">Nurse login</div>
</ng-template>
@if (isMobile) {
  <ng-container
    (deviceUpdatesEmitter)="handlerDeviceUpdatesEmitter()"
    aiomedReceivingData></ng-container>
}
